import { getOadParams } from '@mtfe/sweet-oad';
import http from '../../service';
import store from '../../store';

const { storeCommon, storeCoupon, storeRedBag } = store;
const { storeOptionalWelfare, storeDailyDeals } = storeCoupon;

/**
 * 鲜花实验
 * @param {object} data - 组件数据对象
 * @param {object} events - 组件事件对象
 */
export const experimentBanner = async (data, events) => {
    const { expInfo = {} } = storeCommon.structInfo;
    // 实验逻辑
    let { flowerBannerPicUrl, flowerBannerRedirectUrl } = expInfo;
    try {
        if (flowerBannerPicUrl) {
            data.banner = `background-image:url(${flowerBannerPicUrl})`;
            if (flowerBannerRedirectUrl) {
                const rest = await getOadParams();
                const { pageSrc1, pageSrc2, pageSrc3, activityId } = rest.mediumParams;
                const { rootPvId } = rest;
                events.onClickBanner = () => {
                    window.location.href = flowerBannerRedirectUrl
                        .replace('${rootPvId}', rootPvId)
                        .replace('${pageSrc1}', pageSrc1)
                        .replace('${pageSrc2}', pageSrc2)
                        .replace('${pageSrc3}', pageSrc3)
                        .replace('${activityId}', activityId);
                };
            }
        }
    } catch (error) {
        console.error('鲜花实验出错', error);
    }
};

/**
 * 每日优惠和福利自选的优先展示
 * @param {string} indexDefaultActiveTab - 红包专区与商家券专区默认Tab
 * @returns
 */
export const experimentDefaultTab = (indexDefaultActiveTab) => {
    const { expInfo = {} } = storeCommon.structInfo;
    // 实验逻辑，后端返回的参数都是string
    // cpsNewH5Coupon_self_first: string
    // cpsNewH5Coupon_N: string
    let {
        cpsNewH5Coupon_N: cpsNewH5CouponN,
        cpsNewH5Coupon_selfCouponFirst: cpsNewH5CouponSelfFirst,
    } = expInfo;

    const { isShowCoupon, isShowRedBag } = storeCommon;
    const optionalWelfareInitRecallBizId = storeOptionalWelfare.tabsInfo[0].recallBizId;
    // 解析实验参数
    cpsNewH5CouponN = Number(cpsNewH5CouponN);
    cpsNewH5CouponSelfFirst = cpsNewH5CouponSelfFirst === 'true';
    // 实验逻辑:1、针对仅召回商家券且自选专区可选商家数量大于n个的请求
    // 校验解析后的参数，如果参数不合规则不开启实验
    const isOpenExp =
        isShowCoupon &&
        !isShowRedBag &&
        !Number.isNaN(cpsNewH5CouponN) &&
        storeOptionalWelfare.poiData[optionalWelfareInitRecallBizId].poiList.length >
            cpsNewH5CouponN;

    const couponDefaultActiveTab =
        isOpenExp && cpsNewH5CouponSelfFirst
            ? storeOptionalWelfare.recallBizId
            : storeDailyDeals.recallBizId;

    // 上报实验结果
    try {
        const topShowInfo = { isShowCoupon, isShowRedBag, indexDefaultActiveTab };
        const couponShowInfo = { couponDefaultActiveTab };
        const domId = calculateDomId(topShowInfo, couponShowInfo);
        http.frontMonitorPageLog(domId, expInfo, 'c_waimai_8nv7fbi8');
    } catch (error) {
        // 上报接口不参与业务逻辑，单独捕获错误
        console.error('上报frontMonitorPageLog出错', error);
    }
    return couponDefaultActiveTab;
};

/**
 * 商家券专区中，每日优惠支持领取红包实验
 * @param {boolean} isShowRedBag - 是否展示红包专区
 * @return {boolean} 是否展示红包专区
 */
export const experimentAddRedBagToCoupon = (isShowRedBag) => {
    const { expInfo = {}, struct } = storeCommon.structInfo;
    const { mergeCouponToEveryDay } = expInfo;
    const { dom_wm_red_bag: domWmRedBag, dom_wm_coupon: domWmCoupon } = struct;
    const redBagInfo = storeRedBag.effectData[domWmRedBag.recallBizId];
    try {
        if (mergeCouponToEveryDay && mergeCouponToEveryDay === 'true' && isShowRedBag) {
            // 将红包信息添加到券列表的头部
            storeDailyDeals.effectData[domWmCoupon.recallBizId].couponList.unshift(redBagInfo);
            // 更新总金额
            const redBagAmount = redBagInfo.giftInfo.coupon_amount / 100;
            storeDailyDeals.effectData[domWmCoupon.recallBizId].gift_value += redBagAmount;
            return false;
        }
    } catch (error) {
        console.error('每日优惠支持领取红包实验出错', error);
    }

    return isShowRedBag;
};
// 以下是工具
/**
 * 生成传递给后端的domID字符串，该字符串用来描述页面实际展示的结构。
 * @param {*} pageShowInfo - 描述红包专区、商家券专区展示与否。默认展示。
 * @param {*} couponShowInfo - 描述券专区默认展示。
 */
export const calculateDomId = (pageShowInfo, couponShowInfo) => {
    const { isShowCoupon, isShowRedBag, indexDefaultActiveTab } = pageShowInfo;
    const { couponDefaultActiveTab } = couponShowInfo;
    // 商家券专区domID
    let couponDomID = '';
    if (couponDefaultActiveTab === storeOptionalWelfare.recallBizId) {
        couponDomID = `${storeOptionalWelfare.recallBizId}-${storeDailyDeals.recallBizId}`;
    } else if (couponDefaultActiveTab === storeDailyDeals.recallBizId) {
        couponDomID = `${storeDailyDeals.recallBizId}-${storeOptionalWelfare.recallBizId}`;
    }
    couponDomID = `${storeCoupon.recallBizId}-${couponDomID}`;
    // 红包专区domID
    const redBagDomID = storeRedBag.recallBizId;
    // 页面domID
    let domID = '';
    if (isShowCoupon && isShowRedBag) {
        // 红包专区和券专区都展示
        if (indexDefaultActiveTab === storeCoupon.recallBizId) {
            // 如果是商家券专区先展示
            domID = `${couponDomID}-${redBagDomID}`;
        } else if (indexDefaultActiveTab === storeRedBag.recallBizId) {
            // 如果是红包专区先展示
            domID = `${redBagDomID}-${couponDomID}`;
        }
    } else if (!isShowCoupon && isShowRedBag) {
        // 只有红包专区展示
        domID = redBagDomID;
    } else if (isShowCoupon && !isShowRedBag) {
        // 只有商家券专区展示
        domID = couponDomID;
    }
    return domID;
};
